import { Component, Input } from '@angular/core';

@Component({
    /* Component for displaying a Key Performance Indicator. */
    selector: 'my-kpi-card',
    styleUrls: ['kpi-card.component.scss'],
    templateUrl: 'kpi-card.component.html'
})
export class KpiCardComponent {

    /* Available colors for the KPI component */
    @Input() kpiColor: 'mango'|'blue'|'teal'|'green'|'purple'|'gray';
    /* Available widths for the KPI component */
    @Input() kpiWidth: 'small' | 'medium' | 'large';
    /* Should the KPI component be left align with no margin*/
    @Input() isLeft;
    /* Sets the title string for the KPI component */
    @Input() kpiTitle;
    /* Sets the value for the KPI component */
    @Input() kpiValue;
    /* Sets the image for the KPI Card */
    @Input() kpiImage: 'icon-kpi-pill' | 'icon-kpi-rejects' | 'icon-kpi' | 'icon-kpi-compliance'
        | 'icon-kpi-reversed' | 'icon-kpi-medications' | 'icon-kpi-admissions' | 'icon-kpi-interchange'
        | 'icon-kpi-invoice';
    /* Sets if the card is comming soon card */
    @Input()
    comingSoon: boolean = false;

}
